
// Listen for clicks on the document
document.addEventListener('click', function(event) {
    let target = event.target;

    while (
        target !== document &&
        target.nodeType === Node.ELEMENT_NODE &&
        !target.classList.contains('watch-full-video')
    ) {
        target = target.parentNode;
    }

    if (
        target !== document &&
        target.classList.contains('watch-full-video')
    ) {
        const youtubeEmbedCode = target.getAttribute('data-youtube-embed');
        const youtubeDiv = `<div id="youtubeEmbed">${youtubeEmbedCode}</div>`;

        const videoContainer = document.querySelector('.video-container');
        videoContainer.innerHTML = '';
        videoContainer.innerHTML = youtubeDiv;

        const productVideoPopupWrapper = document.querySelector(
            '.product-video-popup-wrapper'
        );

        fadeIn(productVideoPopupWrapper, 300);
    }
});

// Fade in
function fadeIn(element, duration) {
    element.style.display = 'block';
    element.style.opacity = 0;

    let last = +new Date();

    let tick = function() {
        element.style.opacity =
            +element.style.opacity + (new Date() - last) / duration;

        last = +new Date();

        if (+element.style.opacity < 1) {
            requestAnimationFrame(tick);
        }
    };

    tick();
}

// Close video
document.addEventListener('click', function(event) {
    if (event.target.classList.contains('close-guide')) {
        const popupWrapper = document.querySelector(
            '.product-video-popup-wrapper'
        );

        fadeOut(popupWrapper, 300);

        const iframe = document.querySelector('.video-container iframe');
        if (iframe) iframe.remove();
    }
});

// Fade out
function fadeOut(element, duration) {
    element.style.opacity = 1;
    const start = performance.now();

    requestAnimationFrame(function fade(timestamp) {
        const time = (timestamp - start) / duration;
        element.style.opacity = Math.max(1 - time, 0);

        if (time < 1) {
            requestAnimationFrame(fade);
        } else {
            element.style.display = 'none';
        }
    });
}


// =====================================================
// CABRINHA COUNTRY PURCHASE & OUTLET RESTRICTIONS
// =====================================================

function ipLookUp() {
    fetch('https://api.ipdata.co?api-key=8fd749aec99277661f2fce3e033bc119fa632db378859834ee92a0b9')
        .then(response => response.json())
        .then(response => {

            console.log("User's Location Data is ", response.country_name);

            let buyButtonOverride = false;

            // Replacement Loop exception
            const isReplacementLoopProductPage =
                document.body.classList.contains(
                    'page-handle-c-o-s-loop-kit-with-finger'
                );

            const isReplacementLoopFeaturedProduct =
                document.querySelector(
                    '[data-featured-product-handle="c-o-s-loop-kit-with-finger"]'
                );

            if (
                isReplacementLoopProductPage ||
                isReplacementLoopFeaturedProduct
            ) {
                buyButtonOverride = true;
            }


            // =====================================================
            // COUNTRIES ALLOWED TO PURCHASE FROM CABRINHA
            // Belarus, Kosovo and Czechia excluded
            // =====================================================

            const allowedCountries = [
                'United States',
                'United Kingdom',
                'Albania',
                'Andorra',
                'Austria',
                'Belgium',
                'Bosnia and Herzegovina',
                'Bulgaria',
                'Croatia',
                'Cyprus',
                'Denmark',
                'Estonia',
                'Finland',
                'France',
                'Germany',
                'Greece',
                'Hungary',
                'Iceland',
                'Ireland',
                'Italy',
                'Latvia',
                'Liechtenstein',
                'Lithuania',
                'Luxembourg',
                'Malta',
                'Moldova',
                'Montenegro',
                'Netherlands',
                'North Macedonia',
                'Norway',
                'Poland',
                'Portugal',
                'Romania',
                'Serbia',
                'Slovakia',
                'Slovenia',
                'Spain',
                'Sweden',
                'Ukraine'
            ];


            // =====================================================
            // OUTLET MENU VISIBILITY
            // Same countries as those allowed to purchase
            // =====================================================

// Tell the athlete setup whether online purchasing is allowed
const riderSetup = document.querySelector('#rider-setup');

if (riderSetup) {
    const riderCanBuy =
        allowedCountries.includes(response.country_name) ||
        buyButtonOverride;

    riderSetup.dataset.riderIpCanBuy = riderCanBuy ? 'true' : 'false';

    riderSetup.dispatchEvent(
        new CustomEvent('rider:country-ready', {
            detail: { canBuy: riderCanBuy }
        })
    );
}

            const allowedOutletCountries = allowedCountries;

            if (
                response.country_name &&
                !allowedOutletCountries.includes(response.country_name)
            ) {
                document.querySelectorAll(
                    'header a[href="/collections/cabrinha-outlet"], nav a[href="/collections/cabrinha-outlet"]'
                ).forEach(el => {

                    const parent = el.closest(
                        'li, .menu-item, .drawer__menu-item'
                    );

                    if (parent) {
                        parent.remove();
                    } else {
                        el.remove();
                    }
                });
            }


            // =====================================================
            // RESTRICT PURCHASES FOR NON-APPROVED COUNTRIES
            // =====================================================

// Check Shopify's selected country as well as the visitor's IP
const allowedShopifyCountryCodes = [
  'US', 'GB', 'AL', 'AD', 'AT', 'BE', 'BA', 'BG',
  'HR', 'CY', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR',
  'HU', 'IS', 'IE', 'IT', 'LV', 'LI', 'LT', 'LU',
  'MT', 'MD', 'ME', 'NL', 'MK', 'NO', 'PL', 'PT',
  'RO', 'RS', 'SK', 'SI', 'ES', 'SE', 'UA'
];

const shopifyCountryCanBuy =
  allowedShopifyCountryCodes.includes(
    window.cabrinhaShopifyCountryCanBuy
  );

            if (
  (
    !allowedCountries.includes(response.country_name) ||
    !shopifyCountryCanBuy
  ) &&
  !buyButtonOverride
) {

                // Remove purchase buttons and prices
                document.querySelectorAll('.pdp--buttons')
                    .forEach(el => el.remove());

                document.querySelectorAll(
                    'a[aria-controls="cart-drawer"]'
                ).forEach(el => el.remove());

                document.querySelectorAll(
                    '.product-info__block-item[data-block-type="price"]'
                ).forEach(el => el.remove());

                document.querySelectorAll('.product-price')
                    .forEach(el => el.remove());


                // Replace buy button with Find a Dealer
                const buyButtonsBlock = document.querySelector(
                    '.product-info__block-item[data-block-type="buy-buttons"]'
                );

                if (buyButtonsBlock) {
                    const dealerAnchor = document.createElement('a');

                    dealerAnchor.classList.add(
                        'button',
                        'button--primary',
                        'button--full',
                        'locator-btn'
                    );

                    dealerAnchor.href =
                        'https://www.cabrinha.com/pages/store-locator';

                    dealerAnchor.textContent = 'Find a Dealer';

                    buyButtonsBlock.prepend(dealerAnchor);
                }


                // Complementary products
                setTimeout(function() {

                    if (
                        document.body.classList.contains('template-product')
                    ) {
                        const complementaryProduct =
                            document.querySelectorAll(
                                '.complementary-products__product-list .horizontal-product-card'
                            );

                        complementaryProduct.forEach(product => {

                            const price = product.querySelector(
                                '.complementary-products price-list'
                            );

                            const anchor = product.querySelector('a');
                            const productLink = anchor.getAttribute('href');

                            const addToCartBtns = product.querySelectorAll(
                                '.complementary-product-btn'
                            );

                            const cardInfo = product.querySelector(
                                '.horizontal-product-card__info'
                            );

                            const btn1 = document.createElement('a');

                            btn1.classList.add(
                                '@narrow:horizontal-product-card__button',
                                'link'
                            );

                            btn1.href = productLink;
                            btn1.textContent = 'View Product';

                            cardInfo.append(btn1);


                            const btn2 = document.createElement('a');

                            btn2.classList.add(
                                '@large:horizontal-product-card__button',
                                'button',
                                'button--outline',
                                'button--subdued'
                            );

                            btn2.href = productLink;
                            btn2.textContent = 'View Product';

                            cardInfo.append(btn2);


                            if (price) price.remove();

                            addToCartBtns.forEach(btn => btn.remove());
                        });
                    }

                }, 400);

            } else {

                // =================================================
                // ENABLE ECOMMERCE FOR APPROVED COUNTRIES
                // =================================================

                document.querySelectorAll(
                    '.icon-cart, .top-cart-icon'
                ).forEach(el => {
                    el.style.display = 'inline-block';
                });

                document.querySelectorAll(
                    '.payment_methods'
                ).forEach(el => {
                    el.style.display = 'block';
                });

                document.body.classList.add('ecomm');

                if (
                    document.body.classList.contains('pdp--ecommerce')
                ) {
                    document.querySelectorAll('.pdp--buttons')
                        .forEach(el => {
                            el.style.display = 'block';
                        });
                }
            }

        })
        .catch(error => {
            console.log(
                'Request failed. Returned status of',
                error.message
            );
        });
}

document.addEventListener('DOMContentLoaded', function() {
    ipLookUp();
});


// =====================================================
// SPARE PARTS SEARCH REDIRECT
// =====================================================

(function () {

    const partsStoreUrl = 'https://cabrinha.store/';

    function normalizeSearch(value) {
        return value
            .trim()
            .toLowerCase()
            .replace(/\s+/g, ' ');
    }

    function isPartsSearch(value) {
        const searchTerm = normalizeSearch(value);

        return (
            searchTerm === 'spare' ||
            searchTerm.startsWith('spare part') ||
            searchTerm.startsWith('replacement part')
        );
    }

    document.addEventListener('input', function(event) {
        const input = event.target;

        if (
            input.matches('input[name="q"]') &&
            isPartsSearch(input.value)
        ) {
            window.location.replace(partsStoreUrl);
        }
    });

    document.addEventListener('submit', function(event) {
        const input = event.target.querySelector('input[name="q"]');

        if (input && isPartsSearch(input.value)) {
            event.preventDefault();
            window.location.replace(partsStoreUrl);
        }
    });

})();
